
import {defineComponent, ref, watch} from "vue";
import { properBase } from '../../../../uses/propertyBase';
import { Effects } from './effects';
import 'animate.css';
import './index.scss';
import {WidgetAnimateClass} from "../../../../store/types";
import {aniEmitter} from "../../../Editor/bus";

export default defineComponent({
  name: 'Animate',
  setup(props) {
    const store = properBase().store;
    const activeWidget = properBase().widget;
    const effects = ref(Effects.filter(item => item.toLowerCase().indexOf('out') === -1));
    const selected = ref('');
    const speed = ref('');
    const preview = ref<HTMLElement | null>(null);
    let currentClass = '';
    let speedClass = '';

    const commitCls = (cls: Partial<WidgetAnimateClass>) => {
      store.commit('editor/setAnimateClass', {
        id: activeWidget.value!.id,
        cls
      });
      aniEmitter.emit<void>('animate');
    }

    watch(selected, value => {
      // console.log('wat selected', preview.value);
      if (currentClass) {
        preview.value!.classList.remove(currentClass);
      }
      currentClass = value;
      preview.value!.classList.add(currentClass);
      commitCls({ animate: currentClass });
    });
    watch(speed, value => {
      // console.log('wat selected', preview.value);
      if (speedClass) {
        preview.value!.classList.remove(speedClass);
      }
      speedClass = value;
      preview.value!.classList.add(speedClass);
      commitCls({ speed: speedClass });
    });
    return {
      effects,
      selected,
      speed,
      activeWidget,
      preview
    }
  }
});
